import React, { useState, useRef, useEffect } from "react";
import { Download, FileText, FileJson, ChevronDown } from "lucide-react";

const ExportBlueprint = ({ formData, blueprint }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(e?.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePDF = () => {
    setOpen(false);
    window.print();
  };

  const handleJSON = () => {
    setOpen(false);
    const name = (formData?.name || "blueprint")?.replace(/\s+/g, "-")?.toLowerCase();
    const timestamp = new Date()?.toISOString()?.slice(0, 10);
    const filename = `${name}-blueprint-${timestamp}.json`;
    const exportData = {
      generatedAt: new Date()?.toISOString(),
      profile: formData,
      blueprint,
    };
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a?.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm shadow-md transition-all hover:opacity-90 active:scale-95"
        style={{
          background: "linear-gradient(135deg, #283ba3 0%, #1e2d8a 100%)",
          color: "#fff",
          fontFamily: "var(--font-body)",
          border: "2px solid #d3ac35",
        }}
      >
        <Download size={16} />
        Print My Blueprint
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-56 rounded-xl shadow-xl z-50 overflow-hidden"
          style={{ background: "#fff", border: "1.5px solid #d3ac35" }}
        >
          <div
            className="px-4 py-2.5 text-xs font-bold uppercase tracking-wider"
            style={{ background: "#283ba3", color: "#d3ac35", fontFamily: "var(--font-caption)" }}
          >
            Export Options
          </div>
          <button
            onClick={handlePDF}
            className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-blue-50 transition-colors text-left"
            style={{ color: "#283ba3", fontFamily: "var(--font-body)" }}
          >
            <FileText size={16} style={{ color: "#283ba3" }} />
            <div>
              <div className="font-semibold">Download as PDF</div>
              <div className="text-xs" style={{ color: "#888" }}>Print-ready formatted layout</div>
            </div>
          </button>
          <div style={{ borderTop: "1px solid #f0e8d0" }} />
          <button
            onClick={handleJSON}
            className="flex items-center gap-3 w-full px-4 py-3 text-sm hover:bg-yellow-50 transition-colors text-left"
            style={{ color: "#283ba3", fontFamily: "var(--font-body)" }}
          >
            <FileJson size={16} style={{ color: "#d3ac35" }} />
            <div>
              <div className="font-semibold">Download as JSON</div>
              <div className="text-xs" style={{ color: "#888" }}>Full blueprint data file</div>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportBlueprint;
